import { Software } from '@/types/software';
import { Card } from '@/components/ui/card';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import { SoftwareDetails } from '@/components/SoftwareDetails';

interface SoftwareCardProps {
  software: Software;
}

export const SoftwareCard = ({ software }: SoftwareCardProps) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const getLifespan = (launch: string, end: string) => {
    const launchDate = new Date(launch);
    const endDate = new Date(end);
    const years = endDate.getFullYear() - launchDate.getFullYear();
    return `${years} years`;
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Card className="group bg-gradient-card border-memorial-border hover:border-cyber-glow/50 hover:shadow-glow animate-fade-in-up cursor-pointer transition-all duration-300">
          <div className="space-y-4 p-6 text-center">
            <div className="group-hover:animate-pulse-glow transition-all duration-300">
              {software.image ? (
                <img
                  src={software.image}
                  alt={software.name}
                  className="mx-auto h-16 w-16 object-contain"
                />
              ) : (
                <div className="text-4xl">{software.logo}</div>
              )}
            </div>
            <div>
              <h3 className="text-memorial-text group-hover:text-cyber-glow font-semibold transition-colors duration-300">
                {software.name}
              </h3>
              {software.description && (
                <p className="text-memorial-muted mt-2 line-clamp-2 text-sm">
                  {software.description}
                </p>
              )}
            </div>
            <div className="space-y-2 text-sm">
              <div className="text-memorial-muted flex justify-between">
                <span>Launched:</span>
                <span className="text-memorial-text">{formatDate(software.launchDate)}</span>
              </div>
              <div className="text-memorial-muted flex justify-between">
                <span>Obsolete:</span>
                <span className="text-memorial-text">{formatDate(software.endDate)}</span>
              </div>
              <div className="border-memorial-border border-t pt-2">
                <span className="text-cyber-glow font-medium">
                  Served {getLifespan(software.launchDate, software.endDate)}
                </span>
              </div>
            </div>
          </div>
        </Card>
      </DialogTrigger>

      <SoftwareDetails software={software} />
    </Dialog>
  );
};
